import React from 'react';

import {
	type ActionKeys,
	CREATE_REQUEST_KEY,
	JSM_CREATE_REQUEST_KEY,
	JSM_CREATE_REQUEST_V2_KEY,
} from '@atlassian/conversation-assistant-message-actions-api/constants';
import {
	type ActionRendererFor,
	type ActionRendererKeyToPayload,
	type ActionWith,
} from '@atlassian/conversation-assistant-message-actions-api/types';
import { type MessageAction } from '@atlassian/conversation-assistant-service-api/types/message-actions';

import { JsmCreateRequestActionUnifiedRenderer } from './jsm-create-request-action-unified-renderer';

type JsmCreateRequestActionProps =
	| ActionRendererFor<typeof ActionKeys.JsmCreateRequest>
	| ActionRendererFor<typeof ActionKeys.JsmCreateRequestV2>
	| ActionRendererFor<typeof ActionKeys.CreateRequest>;

export const JsmCreateRequestAction = (props: JsmCreateRequestActionProps): React.JSX.Element => (
	<JsmCreateRequestActionUnifiedRenderer {...props} />
);

export const filterJsmCreateRequestActions = (
	actions: MessageAction[],
): ActionWith<ActionRendererKeyToPayload[typeof ActionKeys.JsmCreateRequest]>[] => {
	return actions.filter(assertIsJsmCreateRequestAction) as ActionWith<
		ActionRendererKeyToPayload[typeof ActionKeys.JsmCreateRequest]
	>[];
};

const assertIsJsmCreateRequestAction = (action: MessageAction): MessageAction => {
	if (
		action.key !== JSM_CREATE_REQUEST_KEY &&
		action.key !== JSM_CREATE_REQUEST_V2_KEY &&
		action.key !== CREATE_REQUEST_KEY
	) {
		throw new Error('Invalid action key for JsmCreateRequestAction');
	}
	return action;
};
